import useMap from "./use-map";

import { Skeleton, VStack } from "@/components/layout";

export const LoadingMap = () => (
  <VStack className="w-full gap-4">
    <h3 className="text-lg font-medium">Location data</h3>
    <Skeleton className="h-[450px] w-full rounded-md" />
  </VStack>
);

export default function Map({ locations }) {
  const mapContainerRef = useMap(locations);
  return (
    <div
      ref={mapContainerRef}
      className="border-cp-grey-300 h-[450px] w-full rounded-md border bg-slate-600"
    />
  );
}
